module.exports = __webpack_public_path__ + "img/m4.53b7962d.jpg";